// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3KIDw","content":"LayoutSettings_content__158Gl"};